// The empty-state card shared by the list screens: a muted line-icon disc, a
// title and a hint, centered in a surface card. Replaces the ad-hoc emoji
// empty states (repo no-emoji rule).

import { type ReactNode } from 'react';

export function EmptyState({
  icon,
  title,
  help,
}: {
  icon: ReactNode;
  title: string;
  help?: string;
}): ReactNode {
  return (
    <div className="flex flex-col items-center gap-2 rounded-2xl bg-surface px-6 py-8 text-center">
      <span className="flex h-11 w-11 items-center justify-center rounded-full bg-raised text-muted">
        {icon}
      </span>
      <p className="text-sm font-medium text-ink">{title}</p>
      {help && <p className="max-w-xs text-xs text-muted">{help}</p>}
    </div>
  );
}
